export const orderDetail = [
  {
    path: `/orderDetail`,
    name: `orderDetail`,
    redirect: `/OrderDetail/detail/:projectId`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/OrderDetail/detail/:projectId/:fileArchive',
        name: 'OrderDetail/detail',
        component: () => import('@/views/orderdetail/OrderDetail')
      }
    ]
  }
];
